import React from 'react';
import { SideDrawer } from '../components/SideDrawer';
import { Search, Bell, User, Plus, Filter, MoreHorizontal, ArrowUpRight } from 'lucide-react';
export function SalesforcePage() {
  return <div className="min-h-screen bg-slate-50 flex font-sans" data-id="element-121" data-mp="2xnqbaiyw2q3x">
      {/* The Side Drawer handles its own fixed positioning and hover state */}
      <SideDrawer data-id="element-122" data-mp="2sunb3rzlwier" />

      {/* Main content fills the canvas; navigation is now a floating popover. */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-123" data-mp="37nqrvx5dis4f">
        {/* Top Header */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6 sticky top-0 z-30" data-id="element-124" data-mp="32mb96bqo4xp7">
          <div className="flex items-center flex-1" data-id="element-125" data-mp="3gjzrbbtcpqqk">
            <h1 className="text-xl font-semibold text-slate-800" data-id="element-126" data-mp="3cm258huvnkre">
              Active Pipeline
            </h1>
          </div>

          <div className="flex items-center space-x-4" data-id="element-127" data-mp="1mae01n0sv57q">
            <div className="relative hidden md:block" data-id="element-128" data-mp="1i7rg08adeol3">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-129" data-mp="1i92fvx0p3c6x" />
              <input type="text" placeholder="Search..." className="pl-9 pr-4 py-2 bg-slate-100 border-transparent rounded-full text-sm focus:bg-white focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20 outline-none transition-all w-64" data-id="element-130" data-mp="sk3omv392ake" />
            </div>
            <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors relative" data-id="element-131" data-mp="1cagrq7140fto">
              <Bell className="w-5 h-5" data-id="element-132" data-mp="1g9xxl1kg7ezd" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-133" data-mp="1lalyqg2e5c7b"></span>
            </button>
            <div className="w-8 h-8 bg-[#C8102E]/10 text-[#C8102E] rounded-full flex items-center justify-center font-semibold text-sm cursor-pointer border border-[#C8102E]/20" data-id="element-134" data-mp="1q8niz4bjzhkd">
              JD
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-6 max-w-7xl mx-auto w-full flex-1" data-id="element-135" data-mp="3jzu8rzxr7rh5">
          {/* Page Actions */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-136" data-mp="3fz1zj6ovtmkv">
            <div data-id="element-137" data-mp="3tya30bs2vguv">
              <p className="text-sm text-slate-500 mb-1" data-id="element-138" data-mp="3tytizmy63v69">
                Q3 FY2026 • Global Sales
              </p>
              <div className="flex items-end gap-3" data-id="element-139" data-mp="3oyp23vtckyfi">
                <h2 className="text-3xl font-bold text-slate-900" data-id="element-140" data-mp="6tu39k500thb">$12.4M</h2>
                <span className="flex items-center text-sm font-medium text-emerald-600 mb-1" data-id="element-141" data-mp="6rr5gdxltw21">
                  <ArrowUpRight className="w-4 h-4 mr-0.5" data-id="element-142" data-mp="2q5z7bfksg0t" />
                  14.2%
                </span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-143" data-mp="bk28hpnn5xyt">
              <button className="px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors flex items-center gap-2 shadow-sm" data-id="element-144" data-mp="bmnaqfruqfx3">
                <Filter className="w-4 h-4" data-id="element-145" data-mp="lkkuor2ohqjw" />
                Filter
              </button>
              <button className="px-4 py-2 bg-[#C8102E] text-white rounded-lg text-sm font-medium hover:bg-[#A50D24] transition-colors flex items-center gap-2 shadow-sm shadow-[#C8102E]/20" data-id="element-146" data-mp="155bdney9q52a">
                <Plus className="w-4 h-4" data-id="element-147" data-mp="v5u8cymxht6u" />
                New Opportunity
              </button>
            </div>
          </div>

          {/* Pipeline Stages (Kanban Board Mockup) */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-148" data-mp="lfr7yddh9cyh">
            {/* Stage 1 */}
            <div className="bg-slate-100/50 rounded-xl p-4 border border-slate-200/60" data-id="element-149" data-mp="q8atpxmbjeed">
              <div className="flex items-center justify-between mb-4" data-id="element-150" data-mp="cgnqfdtyl5m3">
                <h3 className="font-semibold text-slate-700" data-id="element-151" data-mp="hepigo9d4f9p">Discovery</h3>
                <span className="text-xs font-medium bg-slate-200 text-slate-600 px-2 py-1 rounded-full" data-id="element-152" data-mp="hcuxj9y3cn5m">
                  3 Deals
                </span>
              </div>
              <div className="space-y-3" data-id="element-153" data-mp="7g9qkj2ih1z5">
                {[{
                name: 'Acme Corp Upgrade',
                amount: '$120,000',
                close: 'Oct 12'
              }, {
                name: 'TechFlow Enterprise',
                amount: '$45,000',
                close: 'Oct 15'
              }, {
                name: 'Global Industries',
                amount: '$210,000',
                close: 'Nov 01'
              }].map((deal, i) => <div key={i} className="bg-white p-4 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer group" data-id="element-154" data-mp="n0jfwt1kqdpc" data-mpi={i}>
                    <div className="flex justify-between items-start mb-2" data-id="element-155" data-mp="d5rltz77a8zb">
                      <h4 className="font-medium text-slate-900 group-hover:text-[#C8102E] transition-colors" data-id="element-156" data-mp="2cfpzglyd7ua2">
                        {deal.name}
                      </h4>
                      <button className="text-slate-400 hover:text-slate-600" data-id="element-157" data-mp="2f28rlojbyrc4">
                        <MoreHorizontal className="w-4 h-4" data-id="element-158" data-mp="2k0a9i650skm0" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-159" data-mp="2or0evjdg4ngp">
                      <span className="font-semibold text-slate-700" data-id="element-160" data-mp="2tq3m9agwf5ru">
                        {deal.amount}
                      </span>
                      <span className="text-slate-500 text-xs" data-id="element-161" data-mp="1w3who0klhdfh">
                        Close: {deal.close}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Stage 2 */}
            <div className="bg-slate-100/50 rounded-xl p-4 border border-slate-200/60" data-id="element-162" data-mp="2azlsr3o8s65f">
              <div className="flex items-center justify-between mb-4" data-id="element-163" data-mp="3hfxufeq9w65r">
                <h3 className="font-semibold text-slate-700" data-id="element-164" data-mp="3hi1zhzzwrb7m">Proposal</h3>
                <span className="text-xs font-medium bg-blue-100 text-blue-700 px-2 py-1 rounded-full" data-id="element-165" data-mp="3mdply7n09q9f">
                  2 Deals
                </span>
              </div>
              <div className="space-y-3" data-id="element-166" data-mp="1hehkk97sjuvz">
                {[{
                name: 'Stark Logistics',
                amount: '$85,000',
                close: 'Sep 28'
              }, {
                name: 'Wayne Enterprises',
                amount: '$450,000',
                close: 'Oct 05'
              }].map((deal, i) => <div key={i} className="bg-white p-4 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer group" data-id="element-167" data-mp="yoi2i6adbg22" data-mpi={i}>
                    <div className="flex justify-between items-start mb-2" data-id="element-168" data-mp="17mlm2x1sm2r8">
                      <h4 className="font-medium text-slate-900 group-hover:text-[#C8102E] transition-colors" data-id="element-169" data-mp="jwzmi8hidlip">
                        {deal.name}
                      </h4>
                      <button className="text-slate-400 hover:text-slate-600" data-id="element-170" data-mp="5sij94yycivp">
                        <MoreHorizontal className="w-4 h-4" data-id="element-171" data-mp="aj8o8h3gujpv" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-172" data-mp="3s0idkz8yrp91">
                      <span className="font-semibold text-slate-700" data-id="element-173" data-mp="tfpigof9z31">
                        {deal.amount}
                      </span>
                      <span className="text-slate-500 text-xs" data-id="element-174" data-mp="okb9wsqjts09">
                        Close: {deal.close}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Stage 3 */}
            <div className="bg-slate-100/50 rounded-xl p-4 border border-slate-200/60" data-id="element-175" data-mp="jjx5rls2j27i">
              <div className="flex items-center justify-between mb-4" data-id="element-176" data-mp="2zbb9lkqqq7ge">
                <h3 className="font-semibold text-slate-700" data-id="element-177" data-mp="2zdfkwnqyy8qp">Negotiation</h3>
                <span className="text-xs font-medium bg-amber-100 text-amber-700 px-2 py-1 rounded-full" data-id="element-178" data-mp="34b7ernb6c4xj">
                  1 Deal
                </span>
              </div>
              <div className="space-y-3" data-id="element-179" data-mp="2gkir8ymz934k">
                {[{
                name: 'CyberDyne Systems',
                amount: '$1,200,000',
                close: 'Sep 30'
              }].map((deal, i) => <div key={i} className="bg-white p-4 rounded-lg border border-amber-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer group relative overflow-hidden" data-id="element-180" data-mp="34ad3bdzh2nnr" data-mpi={i}>
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-400" data-id="element-181" data-mp="2uji5rdgs01n0"></div>
                    <div className="flex justify-between items-start mb-2" data-id="element-182" data-mp="2qjrhphimvzm6">
                      <h4 className="font-medium text-slate-900 group-hover:text-[#C8102E] transition-colors" data-id="element-183" data-mp="3n0m5woz68hfz">
                        {deal.name}
                      </h4>
                      <button className="text-slate-400 hover:text-slate-600" data-id="element-184" data-mp="3i8b4fhos8nlb">
                        <MoreHorizontal className="w-4 h-4" data-id="element-185" data-mp="14tcel07e2llo" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-186" data-mp="19sp3dqhtm2qw">
                      <span className="font-semibold text-slate-700" data-id="element-187" data-mp="1dqv3ifo5lk2u">
                        {deal.amount}
                      </span>
                      <span className="text-slate-500 text-xs" data-id="element-188" data-mp="1nqdpf1nmjfxj">
                        Close: {deal.close}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>;
}